<template>
  <div>
    <loading :active.sync="isLoading"></loading>

    <div class="app-title">
      <div>
        <h1><i class="fas fa-user-friends"></i> Event</h1>
        <p>[{{ name }}]</p>
      </div>
      <ul class="app-breadcrumb breadcrumb">
        <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
        <li class="breadcrumb-item"><a href="#">Home</a></li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="tile">
          <div class="tile-title-w-btn">
            <h3 class="title">Event</h3>
            <p>
              <!-- <button type="button" class="btn btn-primary">
                <i class="fas fa-plus"></i> เพิ่มผู้ใช้งาน
              </button> -->
            </p>
          </div>
          <div class="tile-body">
            <FullCalendar :options="calendarOptions" />
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="modelId"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Modal title</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form action="">
              <div class="form-group">
                <label for="">วันที่</label>
                <input
                  v-model="data.date"
                  type="text"
                  class="form-control"
                  name=""
                  readonly
                />
              </div>
              <div class="form-group">
                <label for="">ประเภทการทำงานล่วงเวลา</label>
                <select
                  class="custom-select"
                  v-model="data.overtime_type_id"
                  required
                >
                  <option value="" selected>Select one</option>
                  <option
                    :value="item.id"
                    v-for="(item, index) in overtime_types"
                    :key="index"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary">Save</button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import _ from "lodash";
import $ from "jquery";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import usersService from "../services/users.service";
import overtime_typesService from "../services/overtime_types.service";
import overtimesService from "../services/overtimes.service";

import "@fullcalendar/core/vdom"; // solves problem with Vite
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from '@fullcalendar/interaction'

export default {
  components: {
    FullCalendar, // make the <FullCalendar> tag available
  },
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: "dayGridMonth",
        dateClick: this.handleDateClick,
        events: [
          { title: "event 1", date: "2019-04-01" },
          { title: "event 2", date: "2019-04-02" },
        ],
      },
      data: {
        date: "",
        overtime_type_id: "",
      },
      days: moment().daysInMonth(),
      date: moment().date(),
      month: moment().month(),
      year: moment().year(),
      editor: ClassicEditor,
      editorData: "",
      editorConfig: {
        // The configuration of the editor.
      },
      AllDays: [],
      users: [],
      overtimes: [],
      overtime_types: [],
      isLoading: false,
      name: this.$route.name,
    };
  },
  methods: {
    handleDateClick: function (arg) {
      alert("date click! " + arg.dateStr);
    },
    async getUsers() {
      const res = await usersService.getAll();
      this.users = res.data;
    },
    async getOV() {
      const res = await overtimesService.getAll();
      this.overtimes = res.data;
    },
    async getOVTypes() {
      const res = await overtime_typesService.getAll();
      this.overtime_types = res.data;

      // const obj = {};
      // _.forEach(res.data, function (value) {
      //   _.merge(obj, value);
      //   console.log(obj);
      // });
    },
    onClick(id, idPerson) {
      const m = ("0" + this.month).slice(-2);
      const d = ("0" + id).slice(-2);
      const y = this.year;
      const date_in = `${y}-${m}-${d}`;
      this.data.date = date_in;
      this.data.overtime_type_id = "";

      // console.log(('0' + my).slice(-2));
      // console.log(id);
      this.onModal();
    },
    checkDayStop(day) {
      return moment().date(day).weekday();
    },
    async onModal() {
      $("#modelId").modal("show");
      // const { value: fruit } = await this.$swal.fire({
      //   title: "Select field validation",
      //   input: "select",
      //   inputOptions: {
      //     BD: "BD",
      //     CH: "CH",
      //     VC: "VC",
      //     MT: "MT",
      //   },
      //   inputPlaceholder: "Select a OT",
      //   showCancelButton: true,
      //   inputValidator: (value) => {
      //     return new Promise((resolve) => {
      //       if (value) {
      //         resolve();
      //       } else {
      //         resolve("You need to select oranges :)");
      //       }
      //     });
      //   },
      // });
      // if (fruit) {
      //   this.$swal.fire(`You selected: ${fruit}`);
      // }
    },
  },

  created() {
    // this.isLoading = true;

    this.getUsers();
    this.getOV();
    this.getOVTypes();
    const arr = [];

    for (let index = 1; index <= this.days; index++) {
      // console.log(index);
      const m = ("0" + this.month).slice(-2);
      const d = ("0" + index).slice(-2);
      const y = this.year;
      const loopDays = `${y}-${m}-${d}`;
      // console.log(loopDays);
      arr.push(loopDays);
    }
    this.AllDays = arr;
    console.log(arr);
  },
};
</script>

<style>
</style>